// getCheapestGroupOffering :: [GroupOffering] -> GroupOffering
export function getCheapestGroupOffering(groupOfferings) {
  if (!groupOfferings.length) return

  const pricedOfferings = groupOfferings.filter((g) => !g.is_subscription_only)
  let cheapestOffering = pricedOfferings[0]
  for (const offering in pricedOfferings) {
    if (offering.price < cheapestOffering.price) {
      cheapestOffering = offering
    }
  }
  return cheapestOffering
}

// getCheapestLicenseOffering :: [LicenseOffering] -> LicenseOffering
export function getCheapestLicenseOffering(licenseOfferings) {
  if (!licenseOfferings.length) return

  const cheapestRlo = licenseOfferings
    .filter((rlo) => rlo.cost_per_seat >= 0)
    .sort((rloA, rloB) => rloA.cost_per_seat - rloB.cost_per_seat)[0]
  return cheapestRlo
}

// getCheapestSchoolSubscriptionPlan :: [SubscriptionPlan] -> SubscriptionPlan
export function getCheapestSchoolSubscriptionPlan(schoolSubscriptionPlans) {
  if (!schoolSubscriptionPlans.length) return

  let cheapestPlan = schoolSubscriptionPlans[0]
  for (let plan in schoolSubscriptionPlans) {
    if (plan.subscription_plan.amount < cheapestPlan.subscription_plan.amount) {
      cheapestPlan = plan
    }
  }
  return cheapestPlan
}

// getCheapestOffering :: ([LicenseOffering], [GroupOffering]) -> LicenseOffering || GroupOffering
export function getCheapestOffering(groupOfferings, licenseOfferings) {
  const cheapestGrp = getCheapestGroupOffering(groupOfferings)
  const cheapestRlo = getCheapestLicenseOffering(licenseOfferings)
  // both group and license offerings exist, so return cheaper offering
  if (cheapestRlo && cheapestGrp) {
    if (cheapestGrp.price < cheapestRlo.cost_per_seat) {
      return cheapestGrp
    }
    return cheapestRlo
  }
  // not comparing, so return whichever exists
  if (cheapestGrp) return cheapestGrp
  if (cheapestRlo) return cheapestRlo
}

// getPriceForOffering :: GroupOffering|LicenseOffering -> String
export function getPriceForOffering(offering) {
  // offering is a resource license offering w/ cost per seat
  if (offering && offering.hasOwnProperty("cost_per_seat")) {
    if (offering.cost_per_seat >= 0) return offering.cost_per_seat
    return ""
  }
  // offering is a group offering w/ a price
  if (offering && offering.price) {
    return offering.price
  }
  // offering has no price (only included in subscriptions)
  if (offering && offering.is_subscription_only) {
    return ""
  }
  // offering is free
  return "Free"
}

// getPriceForSubscriptionPlan :: SubscriptionPlan -> String
export function getPriceForSubscriptionPlan(plan) {
  if (plan.amount) {
    return plan.amount
  }
  return "Free"
}

// getDescriptorLabelForOffering :: GroupOffering|LicenseOffering -> String
export function getDescriptorLabelForOffering(offering, t) {
  // offering must be a resource license offering
  if (offering && offering.cost_per_seat >= 0) {
    return `/${t("resource.licensing_form.member")}`
    // no descriptor if free
  }
  return ""
}

// getIntervalLabelSubscriptionPlan :: SubscriptionPlan -> String
export function getIntervalLabelSubscriptionPlan(plan) {
  if (plan.amount) {
    return plan.interval === 10 ? "/year" : "/month"
  }
  // no interval if free
  return ""
}
